import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ButtonModule} from '@aztrix/components/button';
import {TranslatePipe} from '@aztrix/translate';

import {ConfirmExpireModalComponent} from './confirm-expire-modal.component';

@NgModule({
  declarations: [ConfirmExpireModalComponent],
  imports: [CommonModule, ButtonModule, TranslatePipe],
  exports: [ConfirmExpireModalComponent],
})
export class ConfirmExpireModalModule {}
